import { testimonials } from "@/mocks/home";

export default function CommunitySection() {
  return (
    <section className="py-16 md:py-20">
      <div className="container-site">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">
            Voices from the Field
          </span>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
            瓜友口中的我们 · 真实口碑
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            在这里找到同好、蹲到后续、倾诉心事，来自不同瓜友的真实声音，是社区最好的名片。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className="flex flex-col rounded-xl border border-background-200/70 bg-background-100/70 p-5"
            >
              <span className="flex h-5 w-5 items-center justify-center text-accent-500">
                <i className="ri-double-quotes-l text-xl"></i>
              </span>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={`${t.name} 的头像`}
                  title={`${t.name} 国产吃瓜社区口碑`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-[11px] text-foreground-600">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-14 overflow-hidden rounded-2xl bg-accent-600 p-8 md:p-12">
          <div className="flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-community-line"></i> 全网瓜友都在这里
              </span>
              <h3 className="mt-3 text-2xl font-black text-background-50 md:text-3xl">
                今晚缺你一个 · 同好已经在线
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/90">
                别做安静的旁观者了，来评论区开麦、进群聊对暗号、去树洞留句话——吃瓜的第一现场永远欢迎新面孔。
              </p>
            </div>
            <a
              href="#hot"
              className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-bold text-background-50 shadow-lift transition hover:-translate-y-0.5 hover:bg-primary-400"
            >
              加入讨论去开席 🍉
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}